import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import { GrainOverlay } from "./components/site/GrainOverlay";
import { AnnouncementBar } from "./components/site/AnnouncementBar";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { TrustStrip } from "./components/site/TrustStrip";
import { ProblemPositioning } from "./components/site/ProblemPositioning";
import { CoreSolutions } from "./components/site/CoreSolutions";
import { WhoWeHelp } from "./components/site/WhoWeHelp";
import { OutcomesMarquee } from "./components/site/OutcomesMarquee";
import { FeaturedWork } from "./components/site/FeaturedWork";
import { WhyTechovarya } from "./components/site/WhyTechovarya";
import { EngagementModels } from "./components/site/EngagementModels";
import { TechnologyEcosystem } from "./components/site/TechnologyEcosystem";
import { ContactSection } from "./components/site/ContactSection";
import { Footer } from "./components/site/Footer";
import { Testimonials } from "./components/site/Testimonials";

import { SolutionPage } from "./pages/SolutionPage";
import { IndustryPage } from "./pages/IndustryPage";
import { AboutPage } from "./pages/AboutPage";
import { WorkIndexPage } from "./pages/WorkIndexPage";
import { CaseStudyPage } from "./pages/CaseStudyPage";
import { Seo } from "./components/site/Seo";

const Landing = () => {
  useEffect(() => {
    document.title =
      "Techovarya — AI Product Engineering & SaaS Development Company";
  }, []);

  return (
    <div className="App min-h-screen bg-[#050505] text-white antialiased selection:bg-[#FF5F1F] selection:text-black">
      <Seo
        title=""
        description="Techovarya is an AI-native product engineering company. We help SaaS companies, startups, and enterprises build intelligent products, modernize complex platforms, and accelerate engineering delivery across 20+ sectors and 10+ countries."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Techovarya",
          url: "https://techovarya.com/",
        }}
      />
      <GrainOverlay />
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <ProblemPositioning />
        <CoreSolutions />
        <WhoWeHelp />
        <OutcomesMarquee />
        <FeaturedWork />
        <Testimonials />
        <WhyTechovarya />
        <EngagementModels />
        <TechnologyEcosystem />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/solutions/:slug" element={<SolutionPage />} />
          <Route path="/industries/:slug" element={<IndustryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/work" element={<WorkIndexPage />} />
          <Route path="/work/:slug" element={<CaseStudyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
            borderRadius: 0,
            fontFamily: "Satoshi, sans-serif",
          },
        }}
      />
    </HelmetProvider>
  );
}

export default App;
